import { Wordmark } from "./Wordmark";
import { IMAGES, ADDRESS, MAPS_URL, CONTACT } from "../../lib/content";
import { scrollToSection } from "../../lib/scroll";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";

const INSTAGRAM_URL = CONTACT.instagram;

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#050505] border-t border-[#d4af37]/12 pt-20 pb-10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand */}
          <div>
            <Wordmark size="text-3xl" />
            <p className="mt-5 text-[#9a968c] leading-relaxed max-w-xs text-sm">
              An exclusive 8-acre hillside community in Kasauli. Conscious
              luxury, crafted to be lived in — and passed down.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <img
                src={IMAGES.diamondLogo}
                alt="Diamond India Builders — Conscious Luxury"
                className="w-16 h-16 object-contain"
              />
              <p className="font-serif-lux text-lg text-[#f5f5f0]">
                Diamond India Builders
              </p>
            </div>
            <a
              data-testid="footer-instagram"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow Diamond India Builders on Instagram"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#d4af37]/30 px-4 py-2 text-xs tracking-[0.14em] uppercase text-[#c9c5ba] hover:border-[#d4af37]/70 hover:text-[#d4af37] transition-colors duration-300"
            >
              <Instagram size={16} className="text-[#d4af37]" strokeWidth={1.5} />
              @diamondindiabuilders
            </a>
          </div>

          {/* Explore */}
          <div className="md:pl-8">
            <p className="text-xs tracking-luxe uppercase text-[#d4af37]">
              Explore
            </p>
            <ul className="mt-6 space-y-3">
              {[
                ["The Estate", "#manifesto"],
                ["Residences", "#residences"],
                ["Amenities", "#amenities"],
                ["Location", "#location"],
                ["Enquire", "#enquire"],
              ].map(([label, href]) => (
                <li key={href}>
                  <button
                    data-testid={`footer-${href.replace("#", "")}`}
                    onClick={() => scrollToSection(href)}
                    className="text-[#9a968c] hover:text-[#d4af37] transition-colors duration-300 text-sm"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs tracking-luxe uppercase text-[#d4af37]">
              Sales Gallery
            </p>
            <ul className="mt-6 space-y-4 text-sm">
              <li className="flex items-start gap-3 text-[#c9c5ba]">
                <MapPin size={16} className="text-[#d4af37] mt-0.5" strokeWidth={1.5} />
                <a
                  data-testid="footer-map-link"
                  href={MAPS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#d4af37] transition-colors"
                >
                  {ADDRESS}
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#c9c5ba]">
                <Phone size={16} className="text-[#d4af37]" strokeWidth={1.5} />
                <a href="tel:+919416004600" className="hover:text-[#d4af37] transition-colors">
                  +91 94160 04600
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#c9c5ba]">
                <Mail size={16} className="text-[#d4af37]" strokeWidth={1.5} />
                <a href="mailto:diamondindiabuilders@gmail.com" className="hover:text-[#d4af37] transition-colors break-all">
                  diamondindiabuilders@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#c9c5ba]">
                <Instagram size={16} className="text-[#d4af37]" strokeWidth={1.5} />
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#d4af37] transition-colors"
                >
                  @diamondindiabuilders
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="my-12 hairline" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#6b6b64]">
          <p>© {year} Sarrgosa · Diamond India Builders. All rights reserved.</p>
          <p className="tracking-wide">
            RERA Reg. No. HPRERA-KSL-2026-XXXX · Artist's impression
          </p>
        </div>
      </div>
    </footer>
  );
}
